
import * as f from 'crypto-js/aes';
import { mode, pad } from 'crypto-js';

export const e = f.encrypt;
export const p = pad.Pkcs7;
export const mo = mode.CBC;
